module.exports = __webpack_public_path__ + "img/B低通锐化10.01a37ee2.png";